import { render, staticRenderFns } from "./InstantUpdateTextArea.vue?vue&type=template&id=14d59383"
import script from "./InstantUpdateTextArea.vue?vue&type=script&lang=ts"
export * from "./InstantUpdateTextArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports